export enum EQueryKeys {
  Agents = 'agents',
  Calls = 'calls',
  GoogleSheets = 'googleSheets',
  Sessions = 'sessions',
}
